import React from 'react';
import PropTypes from 'prop-types';
import Location from '../../molecules/Location';
import Call from '../../molecules/Call';
import HoursOfOperation from '../../molecules/HoursOfOperation';
import OnlineOrderingNavigationHeader from './components/OnlineOrderingNavigationHeader';
import './OnlineOrderingNavigation.css';

export default class OnlineOrderingNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = { height: null };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    const { parentId } = this.props;

    if (typeof document !== `undefined`) {
      const container = document.getElementById(parentId);
      container.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    const { parentId } = this.props;

    if (typeof document !== `undefined`) {
      const container = document.getElementById(parentId);
      container.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll(event) {
    const { minHeight, initialHeight, parentId } = this.props;

    if (typeof document !== `undefined`) {
      const container = document.getElementById(parentId);
      const { scrollTop } = container;
      const height = Math.max(minHeight, initialHeight - scrollTop);

      this.setState({ height });
    }
  }

  render() {
    const {
      businessName,
      logo,
      phoneNumber,
      address,
      hours,
      initialHeight,
      minHeight,
    } = this.props;
    const { height } = this.state;

    return (
      <div className="online-ordering-navigation" style={{ height: height || initialHeight }}>
        <OnlineOrderingNavigationHeader
          businessName={businessName}
          logo={logo}
          atBaseHeight={height === minHeight}
        />
        <div className="contact-info desktop">
          <Location address={address} inline showIcon />
          <Call phoneNumber={phoneNumber} showIcon />
          <HoursOfOperation hours={hours} displayOption="modal" />
        </div>
        <div className="contact-info mobile">
          <Location address={address} inline showIcon as="icon" />
          <Call phoneNumber={phoneNumber} showIcon as="icon" />
          <HoursOfOperation as="icon" hours={hours} displayOption="modal" iconAs="button" />
        </div>
      </div>
    );
  }
}

OnlineOrderingNavigation.propTypes = {
  businessName: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  address: PropTypes.object.isRequired,
  hours: PropTypes.array.isRequired,
  parentId: PropTypes.string.isRequired,
  logo: PropTypes.string,
  initialHeight: PropTypes.number,
  minHeight: PropTypes.number,
};

OnlineOrderingNavigation.defaultProps = {
  logo: '',
  initialHeight: 100,
  minHeight: 70,
};
